import React from "react";
import styled from "styled-components";

export default function PanelHeaderEngine({
  title,
  description,
  actions = [],
  isFullscreen = false,
  onToggleFullscreen,
  onClose,
}) {
  return (
    <PanelHeader>
      <PanelCopy>
        <PanelTitle>{title}</PanelTitle>

        {description && (
          <PanelDescription>{description}</PanelDescription>
        )}
      </PanelCopy>

      <PanelActionBar>
        {actions.map((action) => (
          <PanelIconButton
            key={action.key}
            type="button"
            onClick={action.onClick}
            disabled={Boolean(action.disabled)}
            aria-label={action.label}
            title={action.label}
          >
            <span aria-hidden="true">{action.icon}</span>
          </PanelIconButton>
        ))}

        <PanelIconButton
          type="button"
          onClick={onToggleFullscreen}
          aria-label={
            isFullscreen
              ? "Quitter le plein écran"
              : "Afficher en plein écran"
          }
          title={
            isFullscreen
              ? "Quitter le plein écran"
              : "Afficher en plein écran"
          }
        >
          <span aria-hidden="true">
            {isFullscreen ? "🗗" : "⛶"}
          </span>
        </PanelIconButton>

        <PanelIconButton
          type="button"
          onClick={onClose}
          aria-label="Fermer le panneau"
          title="Fermer le panneau"
        >
          <span aria-hidden="true">×</span>
        </PanelIconButton>
      </PanelActionBar>
    </PanelHeader>
  );
}

const PanelHeader = styled.header`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 1rem;
  margin-bottom: 0.85rem;
  padding: 0 0 0.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  @media (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.65rem;
  }
`;

const PanelCopy = styled.div`
  min-width: 0;
  padding-top: 0.15rem;
`;

const PanelTitle = styled.h2`
  margin: 0;
  color: #f7f7f7;
  font-size: clamp(1.2rem, 1.8vw, 1.55rem);
  font-weight: 650;
  line-height: 1.2;
  letter-spacing: -0.015em;
`;

const PanelDescription = styled.p`
  margin: 0.28rem 0 0;
  max-width: 920px;
  color: rgba(247, 247, 247, 0.62);
  font-size: 0.86rem;
  line-height: 1.38;
`;

const PanelActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  flex-shrink: 0;
`;

const PanelIconButton = styled.button`
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  background: #fff9ea;
  color: #0b1328;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 850;
  line-height: 1;
  transition:
    transform 0.16s ease,
    opacity 0.16s ease,
    background 0.16s ease;

  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    transform: translateY(-1px);
    background: #ffffff;
  }

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;
